import { useTipoRevisao } from "./use-tipo-revisao";
import { TipoRevisaoView } from "./view-tipo-revisao";
import type { TipoRevisaoProps } from "./types-tipo-revisao";

export function TipoRevisao(props: TipoRevisaoProps) {
  const vm = useTipoRevisao(props);

  return <TipoRevisaoView {...props} {...vm} />;
}

export type * from "./types-tipo-revisao";
